<template>
  <div class="location-invalid container f5">
    <img src="/images/comingsoon.png" :alt="$t('Location Not Set-Up')">
    <p>{{ $t("Looks like this location isn't fully ready to monitor. Make sure you have set up the following:") }}</p>
    <ul>
      <li>{{ $t('At least one experience.') }}</li>
      <li>{{ $t('At least one price per experience.') }}</li>
      <li>{{ $t('At least one open/close time price per experience.') }}</li>
      <li>{{ $t('At least one station.') }}</li>
    </ul>
    <p>{{ $t('You can edit all these location options and more by visiting your') }} <a :href="operatorPanelURL">{{ $t("Operator Panel") }}</a>.</p>
    <p>{{ $t('For more detailed instructions on how to set up your location you can visit our') }} <a class="title link-style" href="https://docs.google.com/document/d/1T31NNQ-Ebppa-BL7UK2BD7BPXSCA4K0keCqRXwgfIWo" rel=noopener target=_blank>{{ $t('Setup Guide') }}.</a></p>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component()
export default class LocationInvalid extends Vue {
  get operatorPanelURL () {
    return `//${window.sbvrenv.OPERATOR_URL}`;
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.location-invalid {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 70rem;
  padding-top: var(--spacingXL);

  & img {
    width: 25rem;
    height: 25rem;
    margin-bottom: var(--spacingMd);
  }
  & p, & ul {
    text-align: left;
    width: 100%;
  }
}
</style>
